var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-wrapper"},[_c('nav',{staticClass:"nav"},[_c('router-link',{staticClass:"nav-logo",attrs:{"to":"/"}}),_c('div',{staticClass:"nav-list"},_vm._l((_vm.array),function(item,index){return _c('router-link',{key:index,staticClass:"nav-list-item",class:[
          index === 0 ? 'first-item' : '',
          _vm.$route.path.indexOf(item.path) === 0 ||
          (_vm.$route.path.indexOf('/about-us')===0 &&
            item.path.indexOf('/about-us')===0)
            ? 'nav-list-item--active'
            : ''
        ],attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }